module.exports = __webpack_public_path__ + "img/abbb_pack.fb6dee0b.png";